/*
* Tools for getting information about the domain loading the SDK.
*/
define('utils/domain',[],
function() {
  return {
    getDomain: function() {
      var domain = null;
      if (!domain) {
        try {
          domain = window.top.location.href;
        } catch(e) { }
      }
      if (!domain) {
        try {
          domain = document.referrer;
        } catch(e) { }
      }
      if (!domain) {
        domain = window.location.href;
      }
      return domain;
    },

    isFramed: window.self !== window.top
  };
});

